import gql from "graphql-tag";

export const BOOK_YOUR_DATE_ON_PAVING = gql`
  mutation bookYourDateOnPaving($data: BookYourDateOnPavingInput!){
    bookYourDateOnPaving(data: $data)
  }
`;